/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Summary_BInputs */

const en_rd_summary_b = /** @type {(inputs: Rd_Summary_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close. A couple of gaps will slow an agent down.`)
};

const id_rd_summary_b = /** @type {(inputs: Rd_Summary_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hampir. Ada beberapa celah yang bikin agent melambat.`)
};

/**
* | output |
* | --- |
* | "Close. A couple of gaps will slow an agent down." |
*
* @param {Rd_Summary_BInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_summary_b = /** @type {((inputs?: Rd_Summary_BInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Summary_BInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_summary_b(inputs)
	return en_rd_summary_b(inputs)
});